module.exports = __webpack_public_path__ + "img/pizza-icon.799c3053.svg";